<template>
  <div
    v-if="showLoadingPage < 1"
    key="loadingPage"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="assetContents"
  >
    <div class="m-edition-section-content-subject m-edition-asset-contents">
      <blockquote
        v-if="!tree.length"
        class="quote quote-assets-primary quote-first"
      >
        <p>
          <span>
            {{ $t('mEditionAssetComments.quote.firstText') }}
            {{ $t('mEditionAssetComments.quote.secondText') }}
            <router-link
              :to="`/${this.$t('rPaths.asset')}/${this.$route.params.id}/${this.$t('mEditionMenu.asset.contents.subject')}`"
              class="text-color-assets-primary"
            >
              {{ $t('mEditionMenu.asset.contents.text') }}.
            </router-link>
          </span>
        </p>
      </blockquote>

      <div
        v-if="tree.length"
        class="m-edition-section-content-subject-split-edition"
      >
        <div class="m-edition-section-content-subject-split-edition-item-left">
          <div class="m-edition-asset-comments-submenu">
            <a
              :class="comentariosTipo === 2 ? 'questions-link-active' : 'questions-link'"
              href="#" @click.prevent="setComentariosTipo(2)"
            >
              <i class="fas fa-question"></i>
              <span>
                {{ $t('mEditionAssetComments.submenu.questions') }}
                <span class="pending-number">
                  {{ `(${preguntasPendientes.contenido})` }}
                </span>
              </span>
            </a>
            <a
              :class="comentariosTipo === 1 ? 'comments-link-active' : 'comments-link'"
              href="#" @click.prevent="setComentariosTipo(1)"
            >
              <i class="fas fa-comments"></i>
              <span>
                {{ $t('mEditionAssetComments.submenu.comments') }}
              </span>
            </a>
          </div>

          <MoleculeEditionAssetContentsTreeNode
            v-for="nodo in tree"
            :key="nodo.id"
            :contenido="contenido"
            :disabledSelected="disabledSelected"
            :element="element"
            :is-child="false"
            :nodo="nodo"
            :node-actions="comentariosTipo === 1 ? 'Comments' : 'Questions'"
            node-actions-class="displayed"
          />
        </div>

        <div
          v-if="(comentariosTipo === 1 && showLoadingState < 1) || (comentariosTipo === 2 && showLoadingState < 2)"
          class="m-edition-section-content-subject-split-edition-item-right m-edition-asset-comments text-align-center"
          key="loadingState"
        >
          <img
            alt="loading"
            class="margin-top-xxlarge"
            height="78"
            src="@/assets/loading/loading-animation.gif"
            width="79"
          />
        </div>
        <div
          v-else
          class="m-edition-section-content-subject-split-edition-item-right m-edition-asset-comments"
          key="assetComments"
        >
          <MoleculeContentNode/>
          <MoleculeEditionAssetCommentsCreate
            v-if="comentariosTipo === 1"
            :comentarios-tipo="comentariosTipo"
            :comment="null"
            :contenido="contenido"
          />
          <MoleculeEditionAssetCommentsReplies
            v-for="comentario in comentarios"
            :key="comentario.id"
            :comentarios-tipo="comentariosTipo"
            :comment="comentario"
            :contenido="contenido"
            :is-child="false"
          />
          <p
            v-if="comentarios.length === 0"
            class="font-size-small text-align-center"
          >
            {{
              comentariosTipo === 1
                ? $t('mEditionAssetComments.messages.noComments')
                : $t('mEditionAssetComments.messages.noQuestions')
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetComments',

  components: {
    MoleculeEditionAssetCommentsReplies: () => import('@/components/molecules/MoleculeEditionAssetCommentsReplies'),
    MoleculeEditionAssetContentsTreeNode: () => import('@/components/molecules/MoleculeEditionAssetContentsTreeNode'),
    MoleculeEditionAssetCommentsCreate: () => import('@/components/molecules/MoleculeEditionAssetCommentsCreate'),
    MoleculeContentNode: () => import('@/components/molecules/MoleculeContentNode')
  },

  props: {
    element: Object,
    elementCategorias: Array
  },

  data () {
    return {
      comentarios: [],
      comentariosTipo: 2,
      disabledSelected: false,
      preguntas: [],
      preguntasPendientes: {
        contenido: '-'
      },
      showLoadingState: 0,
      showLoadingPage: 0,
      tree: []
    }
  },

  computed: {
    contenido () {
      return Object.assign({}, this.$store.getters.getAssetContents[0])
    },

    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    '$store.getters.getAssetSelectedNode' () {
      this.showLoadingState = 0
      this.readContenidoPreguntasPendientes()
    },

    updatedData () {
      this.readContenidoPreguntasPendientes()
    }
  },

  created () {
    this.setComentariosTipo(this.comentariosTipo)
  },

  methods: {
    buildTree (nodos, preguntas) {
      nodos.forEach((nodo, index) => {
        nodos[index] = {
          ...nodo,
          total: preguntas[index].total
        }
        if (nodos[index].children.length) {
          this.buildTree(nodos[index].children, preguntas[index].children)
        }
      })
    },

    readContenidoComentarios (concat = false) {
      if (this.$store.getters.getAssetSelectedNode.id) {
        let tipoComentario = concat ? 3 : this.comentariosTipo
        this.$services.read('contenido', 'readContenidoComentarios', {},
          [this.contenido.id, this.$store.getters.getAssetSelectedNode.id],
          { tipo_comentario: tipoComentario })
          .then(response => {
            switch (tipoComentario) {
              case 1:
                this.comentarios = [...response.data]
                break
              case 2:
                this.preguntas = [...response.data]
                this.readContenidoComentarios(true)
                break
              case 3:
                this.preguntas = this.preguntas.concat(response.data)
                this.comentarios = [...this.preguntas]
                break
            }
          })
          .then(() => {
            this.tree = [...this.$store.getters.getAssetNodes]
            if (this.tree.length) {
              this.buildTree(this.tree, this.preguntasPendientes.nodos)
            }
            this.showLoadingPage++
            this.showLoadingState++
          })
          .catch(error => {
            console.log(error)
            this.showLoadingPage++
            this.showLoadingState++
          })
      }
    },

    readContenidoPreguntasPendientes () {
      this.$services.read('contenido', 'readContenidoPreguntasPendientes', {}, [this.contenido.id])
        .then(response => {
          this.preguntasPendientes = response.data
          this.readContenidoComentarios()
        })
        .catch(error => {
          console.log(error)
          this.showLoadingPage++
          this.showLoadingState++
        })
    },

    setComentariosTipo (tipo) {
      this.comentariosTipo = tipo
      this.showLoadingState = 0
      this.readContenidoPreguntasPendientes()
    }
  }
}
</script>
